import { Component, OnInit } from '@angular/core';
import { TutorService } from 'src/app/services/tutor.service';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tutors',
  templateUrl: './tutors.component.html',
  styleUrls: ['./tutors.component.scss']
})
export class TutorsComponent implements OnInit {
  public paginatedTutors = new BehaviorSubject<any>(null);
  public loadedTutors:boolean=false;
  public availableFilters=[];
  public filterString='';
  public sorts='';
  public page:number=1;
  public perPage:number=20;

  constructor(
    private _tutors: TutorService,
    private _router: Router
  ) {
    this.availableFilters.push(new FilterOption({
      name: 'name',
      type: 'string'
    }));
  }

  public getTutors(page, perPage){
    this._tutors.getTutorsPaginated(page, perPage, this.sorts, this.filterString).subscribe(paginatedData=>{
      this.paginatedTutors.next(paginatedData);
      this.loadedTutors = true;
    })
  }

  public addTutor(){
    if(confirm('Confirm you want to add a new Tutor')){
      this._tutors.addTutor().subscribe(
        (res:any) => {
          this._router.navigate(['/tutors/' + res.id]);
        }
      );
    }
  }

  sortChanged(data){
    this.sorts=data;
    this.getTutors(1, this.perPage);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getTutors(1, this.perPage);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getTutors(data.pageIndex+1, this.perPage);
  }

  perPageChanged(data){

  }

  ngOnInit() {
    this.getTutors(this.page, this.perPage);
  }

}
